import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { StatsBar } from "./components/StatsBar";
import { About } from "./components/About";
import { Services } from "./components/Services";
import { Timeline } from "./components/Timeline";
import { Leadership } from "./components/Leadership";
import { Gallery } from "./components/Gallery";
import { Clients } from "./components/Clients";
import { CtaBand } from "./components/CtaBand";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { NotFound } from "./components/NotFound";
import { useReveal } from "./hooks/useReveal";

const HomePage = () => {
  useReveal();
  return (
    <>
      <Header />
      <main>
        <Hero />
        <StatsBar />
        <About />
        <Services />
        <Timeline />
        <Leadership />
        <Gallery />
        <Clients />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster
          position="top-right"
          theme="light"
          toastOptions={{
            style: {
              borderRadius: 0,
              border: "1px solid rgba(11,37,69,0.15)",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
